
import { Component, Prop, Vue } from 'vue-property-decorator';
import { SapInvoice } from '@/api/model';
import OrderCard from '@/components/orders/OrderCard.vue';

@Component({
  components: { OrderCard },
})
export default class ShowSalesOrder extends Vue {
  @Prop(Object)
  invoice!: SapInvoice;

  @Prop(String)
  label!: string;

  showSalesOrderModal = false;

  get salesOrder() {
    return this.$store.getters['order/findOrderById'](
      this.invoice.SalesOrderId,
    );
  }

  async showSalesOrder() {
    this.showSalesOrderModal = true;
    try {
      await this.$store.dispatch('order/fetchOrder', this.invoice.SalesOrderId);
    } catch {
      this.showSalesOrderModal = false;
    }
  }

  close() {
    this.showSalesOrderModal = false;
  }
}
